import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { Dayreport } from 'src/app/classes/dayreport.class';
import { Planning } from 'src/app/classes/planning.class';
import { Realisation } from 'src/app/classes/realisation';
import { DayreportService } from 'src/app/services/dayreport.service';
import { PlanningService } from 'src/app/services/planning/planning.service';
import { RealisationService } from 'src/app/services/realisation.service';
import { DagrapportStatus } from 'src/environments/trackline/status.dagrapport';

@Injectable()
export class DayReportStateService {
    loadingData$ = new BehaviorSubject<boolean>(false);
    planning$ = new BehaviorSubject<Planning | null>(null);
    dayReport$ = new BehaviorSubject<Dayreport | null>(null);
    realisations$ = new BehaviorSubject<Realisation[]>([]);

    constructor(
        private planningService: PlanningService,
        private dayreportService: DayreportService,
        private realisationService: RealisationService
    ) {}

    loadByPlanningId(planningId: number) {
        let initialDataLoaded = false;
        this.loadingData$.next(true);

        return combineLatest([
            this.dayreportService.getByPlanningId(planningId),
            this.planningService.getSingle(planningId),
            this.realisationService.getPlanningRealisations(planningId),
        ]).subscribe({
            next: ([dayreport, planning, realisations]) => {
                this.loadingData$.next(false);

                this.planning$.next(planning);

                if (initialDataLoaded) {
                    return;
                }
                initialDataLoaded = true;

                this.realisations$.next(realisations.data ?? []);

                if (dayreport.data) {
                    this.dayReport$.next(dayreport.data);
                } else {
                    const newDayreport = new Dayreport();

                    newDayreport.planning_id = planning.id;
                    newDayreport.status_key = DagrapportStatus.DagrapportGepland;
                    newDayreport.comment = undefined;
                    newDayreport.article_dayreports = [];

                    this.dayReport$.next(newDayreport);
                }
            },
            error: () => {
                this.loadingData$.next(false);
            },
        });
    }

    updateDayReport(dayReport: Dayreport) {
        this.dayReport$.next(dayReport);
    }
}
